







































































































































import { Component, Vue } from "vue-property-decorator";
import { IAppList, Callback, IWhoAmI, UserRoles, ROLES_LIST } from "@/interfaces";
import { Action, Getter, State } from "vuex-class";
import {
  RimRepairLoadingComponent,
  RimRepairLogoutConfirmComponent,
  RimRepairModalComponent
} from "@/components/common";

@Component({
  components: {
    RimRepairLoadingComponent,
    RimRepairLogoutConfirmComponent,
    RimRepairModalComponent
  }
})
export default class HomeComponent extends Vue {
  @Action("load", { namespace: "AppModule" })
  public loadAction!: Callback;
  @Getter("user", { namespace: "AppModule" })
  public user!: IWhoAmI | null;
  @Getter("loading", { namespace: "AppModule" })
  public loading!: boolean;
  public drawer = false;
  public items: IAppList[] = [
    {
      name: "Dashboard",
      icon: "widgets",
      route: "/dashboard"
    },
    {
      name: "Users Admin",
      icon: "supervisor_account",
			route: "/users",
			rol: "20"
    },
    {
      name: "Office Admin",
      icon: "view_module",
      route: "/office",
      rol: "20"
    },
    {
      name: "Shop Manager",
      icon: "perm_identity",
      route: "/shop-manager",
      rol: "10"
    },
    {
      name: "Tech Admin",
      icon: "person",
      route: "/technician",
      rol: "0"
    }
  ];
  public dialog = false;

  mounted() {
    if (!this.user) {
      this.loadAction();
    }
  }

  openDrawer(): void {
    this.drawer = true;
  }

  goTo(path: string): void {
    if (this.$route.path !== path) this.$router.push(path);
	}

	showRole(rol: UserRoles){
		var r = ROLES_LIST.filter(r=>r.value==rol );
		return r[0].text;
	}

  disableRoute(rol?: UserRoles) {
    if (!this.user || !rol) return false;
    let disabled =
      this.user.Roles.includes(30) || this.user.Roles.includes(+rol);
    return !disabled;
	}
		
	public IsInvoicesController(): boolean{
		if (!this.user || !this.user.Roles || this.user.Roles.length==0)
			return false;
		
		return this.user.Roles.includes(10) ||this.user.Roles.includes(30);
	}

}


